import styled from 'styled-components';

export const SwitchButton = styled.button`
  border: none;
  border-radius: 3px;
  width: 150px;
  height: 50px;
  background-color: ${props => (props.active ? '#9ff' : '#ccc')}}
`;

export const InputWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;
